"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatingConditionModes = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const condition_mode_denormalized_1 = require("../../../../DataScience/Types/condition-mode-denormalized");
const generate_readable_id_1 = require("../../../../GenerateReadableId/generate-readable-id");
const form_latest_1 = require("./normalized-signal-drive-modes-form/form-schemas/form-latest");
class OperatingConditionModes {
    static fromMode(mode, signals) {
        const [denormalized] = (0, condition_mode_denormalized_1.convertModeBaseToConditionModeDenormalized)(mode, signals, sigma_engine_shared_1.BoundaryCharacteristic.Voltage);
        if (denormalized === undefined) {
            return null;
        }
        const value = OperatingConditionModes.toValue(denormalized);
        return value === null ? null : { id: mode.id, value, readOnly: true };
    }
    static toMode(value, targetName) {
        const bounds = OperatingConditionModes.toBounds(value);
        const denormalized = {
            id: (0, generate_readable_id_1.generateReadableConditionModeId)(targetName, bounds.min, bounds.nominal, bounds.max),
            characteristic: sigma_engine_shared_1.BoundaryCharacteristic.Voltage,
            minVal: bounds.min,
            nominalVal: bounds.nominal,
            maxVal: bounds.max,
            targetSignalId: value.targetSignalId ?? '',
            relativeSignalId: value.relativeSignalId ?? '',
        };
        return (0, condition_mode_denormalized_1.convertConditionModeToModeBase)(denormalized);
    }
    static toValue(denormalized) {
        const { minVal, nominalVal, maxVal, targetSignalId, relativeSignalId } = denormalized;
        if (minVal !== null && maxVal !== null) {
            return {
                targetSignalId,
                operator: form_latest_1.OperatingConditionOperator.Range,
                valueA: minVal,
                valueB: maxVal,
                relativeSignalId,
            };
        }
        if (minVal !== null) {
            return {
                targetSignalId,
                operator: form_latest_1.OperatingConditionOperator.Minimum,
                valueA: minVal,
                valueB: 0,
                relativeSignalId,
            };
        }
        if (maxVal !== null) {
            return {
                targetSignalId,
                operator: form_latest_1.OperatingConditionOperator.Maximum,
                valueA: maxVal,
                valueB: 0,
                relativeSignalId,
            };
        }
        if (nominalVal !== null) {
            return {
                targetSignalId,
                operator: form_latest_1.OperatingConditionOperator.Absolute,
                valueA: nominalVal,
                valueB: 0,
                relativeSignalId,
            };
        }
        return null;
    }
    static toBounds(value) {
        switch (value.operator) {
            case form_latest_1.OperatingConditionOperator.Range:
                return { min: Math.min(value.valueA, value.valueB), nominal: null, max: Math.max(value.valueA, value.valueB) };
            case form_latest_1.OperatingConditionOperator.Minimum:
                return { min: value.valueA, nominal: null, max: null };
            case form_latest_1.OperatingConditionOperator.Maximum:
                return { min: null, nominal: null, max: value.valueA };
            case form_latest_1.OperatingConditionOperator.Absolute:
                return { min: null, nominal: value.valueA, max: null };
        }
    }
    static valuesEqual(left, right) {
        return (left.targetSignalId === right.targetSignalId &&
            left.operator === right.operator &&
            left.valueA === right.valueA &&
            left.valueB === right.valueB &&
            left.relativeSignalId === right.relativeSignalId);
    }
}
exports.OperatingConditionModes = OperatingConditionModes;
//# sourceMappingURL=operating-condition-modes.js.map